<template>
    <div>
        上のリンク・ボタンを押すことで<br/>かけはしメモリーの<a href="/terms-of-service" target="_blank">利用規約</a>・<a href="/privacy-policy" target="_blank">プライバシーポリシー</a>に同意したとみなします
    </div>
</template>

<script>
export default {
name: "NotifyAgreement"
}
</script>

<style scoped>

</style>
